import api from '../api';

export const GetActiveLoginBanner = async () => {
    try {
        const { data } = await api.get<{ Data: { image: string | null } }>('v1/Sac/GetActiveLoginBanner');

        return { data: data.Data?.image ?? null };
    } catch (error) {
        console.error('error', error);
        return { data: null };
    }
}
